import { render, staticRenderFns } from "./BottomSheetRefuseNotifications.vue?vue&type=template&id=5084efbe&scoped=true&"
import script from "./BottomSheetRefuseNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetRefuseNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetRefuseNotifications.vue?vue&type=style&index=0&id=5084efbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5084efbe",
  null
  
)

component.options.__file = "BottomSheetRefuseNotifications.vue"
export default component.exports